// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ok_My1 {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
}

.ePtxH_ {
  font-size: 14px;
  line-height: 1.2;
}

.pZFr7S {
  padding: 6px 12px;
  font-size: 12px;
  line-height: 1.3;
}

.NtRMHn {
  padding: 8px 16px;
  font-size: 14px;
  line-height: 1.4;
}

/* Status variants */
.KuzsA_ {
  color: var(--status-error);
}

.TAl2C9 {
  color: var(--status-info);
}

.sBAZqz {
  color: var(--status-success);
}

.Gq0_TW {
  color: var(--text-neutral-strong);
}

.Nx_byv {
  color: var(--status-info);
}

.Ok_My1.LF9qkp {
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);
}

.LF9qkp.TAl2C9 {
  color: #1573d3;
}

.LF9qkp.sBAZqz {
  color: #387c2b;
}

.LF9qkp.Gq0_TW {
  color: #999;
}

@media (prefers-contrast: high) {
  .Ok_My1 {
    border-width: 2px;
    font-weight: 600;
  }

  .KuzsA_ {
    background-color: #ffc107;
    color: #000000;
  }

  .TAl2C9 {
    background-color: #17a2b8;
    color: #ffffff;
  }

  .sBAZqz {
    background-color: #28a745;
    color: #ffffff;
  }

  .Gq0_TW {
    background-color: #dc3545;
    color: #ffffff;
  }

  .Nx_byv {
    background-color: #6c757d;
    color: #ffffff;
  }
}

@media (prefers-reduced-motion: reduce) {
  .Ok_My1 {
    transition: none;
  }

  .Ok_My1:hover {
    transform: none;
  }
}

@media (max-width: 768px) {
  .ePtxH_ {
    font-size: 9px;
    padding: 3px 6px;
  }

  .pZFr7S {
    font-size: 11px;
    padding: 5px 10px;
  }

  .NtRMHn {
    font-size: 13px;
    padding: 7px 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeStatusBadge/RechargeStatusBadge.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".badge {\n  display: inline-flex;\n  align-items: center;\n  font-weight: 500;\n}\n\n.sizeSmall {\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.sizeMedium {\n  padding: 6px 12px;\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.sizeLarge {\n  padding: 8px 16px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Status variants */\n.statusPending {\n  color: var(--status-error);\n}\n\n.statusReleasing {\n  color: var(--status-info);\n}\n\n.statusReleased {\n  color: var(--status-success);\n}\n\n.statusCancelled {\n  color: var(--text-neutral-strong);\n}\n\n.statusDefault {\n  color: var(--status-info);\n}\n\n.badge.migrationHistory {\n  padding: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.6;\n  font-family: var(--font-family-base, 'Source Sans 3', Arial, sans-serif);\n}\n\n.migrationHistory.statusReleasing {\n  color: #1573d3;\n}\n\n.migrationHistory.statusReleased {\n  color: #387c2b;\n}\n\n.migrationHistory.statusCancelled {\n  color: #999;\n}\n\n@media (prefers-contrast: high) {\n  .badge {\n    border-width: 2px;\n    font-weight: 600;\n  }\n\n  .statusPending {\n    background-color: #ffc107;\n    color: #000000;\n  }\n\n  .statusReleasing {\n    background-color: #17a2b8;\n    color: #ffffff;\n  }\n\n  .statusReleased {\n    background-color: #28a745;\n    color: #ffffff;\n  }\n\n  .statusCancelled {\n    background-color: #dc3545;\n    color: #ffffff;\n  }\n\n  .statusDefault {\n    background-color: #6c757d;\n    color: #ffffff;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n\n  .badge:hover {\n    transform: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .sizeSmall {\n    font-size: 9px;\n    padding: 3px 6px;\n  }\n\n  .sizeMedium {\n    font-size: 11px;\n    padding: 5px 10px;\n  }\n\n  .sizeLarge {\n    font-size: 13px;\n    padding: 7px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `Ok_My1`,
	"sizeSmall": `ePtxH_`,
	"sizeMedium": `pZFr7S`,
	"sizeLarge": `NtRMHn`,
	"statusPending": `KuzsA_`,
	"statusReleasing": `TAl2C9`,
	"statusReleased": `sBAZqz`,
	"statusCancelled": `Gq0_TW`,
	"statusDefault": `Nx_byv`,
	"migrationHistory": `LF9qkp`
};
module.exports = ___CSS_LOADER_EXPORT___;
